var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import Icon from "@ant-design/icons";
var ProfileSvg = /* @__PURE__ */ __name(function ProfileSvg2() {
  return /* @__PURE__ */ React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M30.724 30.222h-2.222v-0.996c0-3.449-0.116-3.556-1.356-3.853-0.791-0.169-1.538-0.298-2.258-0.422-2.911-0.507-5.427-0.951-6.782-3.738-0.729-1.333-1.147-2.564 0.444-5.173 2.6-4.356 2.053-8.991 0.889-10.747-0.631-0.938-1.969-1.516-3.511-1.516s-2.876 0.573-3.484 1.502c-1.391 2.178-1.56 6.707 0.889 10.773 1.373 2.502 1.222 3.747 0.444 5.164-1.333 2.782-3.804 3.227-6.64 3.716-0.72 0.129-1.467 0.262-2.267 0.444-1.236 0.276-1.333 0.4-1.333 3.853v0.991h-2.222v-0.996c0-3.329 0-5.333 3.111-6.022 0.849-0.187 1.653-0.333 2.36-0.444 2.902-0.516 4.218-0.818 5.031-2.52l0.027-0.058c0.373-0.68 0.622-1.133-0.413-3.013-2.947-4.858-2.653-10.276-0.853-13.102 1.040-1.578 3.036-2.516 5.333-2.516s4.311 0.938 5.333 2.502c1.804 2.667 2.138 8.187-0.813 13.133-1.071 1.747-0.844 2.16-0.391 2.982l0.027 0.053c0.822 1.716 2.182 2.018 5.173 2.538 0.707 0.124 1.511 0.262 2.356 0.444 3.111 0.702 3.111 2.707 3.111 6.022v0.996z"
  }));
}, "ProfileSvg");
var ProfileIcon = /* @__PURE__ */ __name(function ProfileIcon2(props) {
  return /* @__PURE__ */ React.createElement(Icon, _extends({
    component: ProfileSvg
  }, props));
}, "ProfileIcon");
export {
  ProfileIcon
};
